import { DECISION_LABEL } from '../components/DecisionTypeRadios';
import { findingTitle, fmtDateTime } from './findingLabels';

// One block per chosen note — what it is about (object and finding), the
// decision, the reasoning and who wrote it when — so IT support can see the
// problem without opening NordComply.
export function buildSupportMailto(notes, tenantName, recipient) {
  const to = recipient ? encodeURIComponent(recipient) : '';
  const subject = encodeURIComponent(`[${tenantName || 'NordComply'}] Spørgsmål vedr. audit — ${notes.length} ${notes.length === 1 ? 'punkt' : 'punkter'}`);
  const body = encodeURIComponent(
    `Hej,\n\nVi har brug for hjælp til følgende ${notes.length} ${notes.length === 1 ? 'punkt' : 'punkter'} fra vores Microsoft 365-audit:\n\n` +
    notes.map((n, i) => {
      const fund = findingTitle(n.findingKey);
      return `${i + 1}) ${n.title || n.pageLabel}\n` +
        (fund ? `Fund: ${fund}\n` : '') +
        `Beslutningstype: ${n.decisionType ? DECISION_LABEL[n.decisionType] : 'Ikke fastsat'}\n` +
        `Begrundelse: ${n.text}\n` +
        `Skrevet af: ${n.authorName || 'Ukendt'}, ${fmtDateTime(n.createdAt)}`;
    }).join('\n\n') +
    `\n\nKan I hjælpe med at kigge på disse?`
  );
  return `mailto:${to}?subject=${subject}&body=${body}`;
}

// The IT list: one mail with every point the customer collected, opened in their own mail program (as "Send til support" does).
// items are the list's points (title, area, tone, count, optionally objects: [name]); message is the customer's own note;
// sender is the person's name. Every point: a number and its title, the area and how many, and the objects when they were picked.
export function buildItMailto(items, tenantName, recipient, message) {
  const to = recipient ? encodeURIComponent(recipient) : '';
  const n = items.length;
  const subject = encodeURIComponent(`[${tenantName || 'NordComply'}] Hjælp til ${n} ${n === 1 ? 'punkt' : 'punkter'} fra NordComply`);
  const blocks = items.map((i, k) => {
    const meta = [i.area, i.count ? `${i.count} ${i.tone === 'bad' ? 'kræver handling' : 'bør gennemgås'}` : ''].filter(Boolean).join(' · ');
    const objects = Array.isArray(i.objects) && i.objects.length > 0 ? '\n' + i.objects.map((o) => `   - ${typeof o === 'string' ? o : o.name}${o && o.note ? `\n     Beslutning: ${o.note}` : ''}`).join('\n') : '';
    const detail = i.detail ? `\n   ${i.detail}` : '';
    return `${k + 1}. ${i.title}${meta ? `\n   ${meta}` : ''}${detail}${objects}`;
  });
  const note = message && message.trim() ? `${message.trim()}\n\n` : '';
  const body = encodeURIComponent(
    `Hej,\n\nVi har brug for hjælp til følgende ${n === 1 ? 'punkt' : `${n} punkter`} fra vores Microsoft 365-gennemgang i NordComply:\n\n${blocks.join('\n\n')}\n\n${note}På forhånd tak.`
  );
  return `mailto:${to}?subject=${subject}&body=${body}`;
}
